/** Session key names passed to `createRlsDb` / `mapSessionToContext`. */
export const RLS_SESSION_KEY_RE = /^[a-zA-Z][a-zA-Z0-9_]*$/;

/**
 * Maps a flat session key to a PostgreSQL GUC name: `app.` + snake_case(key).
 *
 * @example sessionKeyToGucName("userIdentity") → "app.user_identity"
 * @example sessionKeyToGucName("currentUserId") → "app.current_user_id"
 */
export function sessionKeyToGucName(sessionKey: string): string {
  if (!RLS_SESSION_KEY_RE.test(sessionKey)) {
    throw new Error(
      `createRlsDb: session key "${sessionKey}" is invalid — use camelCase identifiers (e.g. userIdentity, tenantId)`,
    );
  }
  return `app.${toSnakeCase(sessionKey)}`;
}

function toSnakeCase(key: string): string {
  return key
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1_$2")
    .replace(/([a-z\d])([A-Z])/g, "$1_$2")
    .toLowerCase()
    .replace(/[^a-z0-9_]+/g, "_")
    .replace(/^_+|_+$/g, "");
}

/**
 * Stringifies a user field for transaction-local RLS GUCs.
 *
 * - boolean → `"true"` / `"false"` (lowercase)
 * - number → decimal string
 * - null/undefined → `""`
 */
export function stringifySessionValue(value: unknown): string {
  if (value === true) return "true";
  if (value === false) return "false";
  if (typeof value === "number") return String(value);
  if (value == null) return "";
  return String(value);
}
